export const numberStringRegExp = /^\d+$/;
